import React from 'react';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { media } from '../themes/theme';
import { isAbsoluteLink } from '../utils/isAbsoluteLink';
import { FocusStylesInverted } from '../../styles/FocusStyles';
import { AssistiveTechnologyOnly } from '../../styles/AssistiveTechnologyOnly';
const LegalNavigationLinkCss = css `
  color: ${props => props.theme.White};
  text-decoration: none;
  display: flex;
  align-items: center;
  font-size: 1rem;

  ${FocusStylesInverted};

  :hover {
    text-decoration: underline;
  }

  ${media.laptop `
    font-size: .875rem;
  `}
`;
export const LegalNavigationItem = styled.li `
  list-style: none;
  line-height: 2rem;
  margin-right: 0;

  ${media.tablet `
    line-height: 2rem;
  `}

  ${media.laptop `
    line-height: initial;
    padding-right: 1.4rem;
  `}
`;
const LegalNavigationLinkInner = styled(Link) `
  ${LegalNavigationLinkCss}
`;
const LegalNavigationAInner = styled.a `
  ${LegalNavigationLinkCss}
`;
export function LegalNavigationLink({ children, to, className = undefined, dataTestId = undefined, }) {
    return (React.createElement(LegalNavigationItem, { className: className, "data-testid": dataTestId }, isAbsoluteLink(to) ? (React.createElement(LegalNavigationAInner, { href: to, target: "_blank", rel: "noopener noreferrer" }, children)) : (React.createElement(LegalNavigationLinkInner, { to: to }, children))));
}
const NavList = styled.ul `
  display: flex;
  align-items: center;
  width: auto;
  flex-direction: column;

  & > li:last-child {
    margin-right: 0;
  }

  ${media.laptop `
    padding-left: 2rem;
    padding-right: 2rem;
    flex-direction: row;
  > *:last-child {
      padding-right: 0;
    }
  `};
`;
const VisuallyHiddenLabel = styled.h2 `
  ${AssistiveTechnologyOnly}
`;
const ID_LEGAL_NAVIGATION_LABEL = 'legal-navigation-label';
export function LegalNavigation({ className = undefined, children, dataTestId = undefined, }) {
    const { t } = useTranslation('Footer');
    return (React.createElement("nav", { "aria-labelledby": ID_LEGAL_NAVIGATION_LABEL, "data-testid": dataTestId, className: className },
        React.createElement(VisuallyHiddenLabel, { id: ID_LEGAL_NAVIGATION_LABEL }, t('LegalNavigationLabel')),
        React.createElement(NavList, null, children)));
}
